import { AstNodeCategory, AstNodeType } from './node';
export class HashLiteral {
    constructor(token, pairs) {
        this.token = token;
        this.pairs = pairs;
        this.nodeType = AstNodeType.HashLiteral;
        this.nodeCategory = AstNodeCategory.Expression;
    }
    get Pairs() {
        return this.pairs;
    }
    setPair(key, value) {
        this.pairs.set(key, value);
    }
    tokenLiteral() {
        return this.token.literal;
    }
    toString() {
        const pairs = [];
        this.pairs.forEach((value, key) => {
            pairs.push(`${key.toString()}:${value.toString()}`);
        });
        return `{${pairs.join(',')}}`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGFzaExpdGVyYWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2FzdC9IYXNoTGl0ZXJhbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsZUFBZSxFQUFFLFdBQVcsRUFBYyxNQUFNLFFBQVEsQ0FBQztBQUVsRSxNQUFNLE9BQU8sV0FBVztJQUNwQixZQUNZLEtBQVksRUFDWixLQUFrQztRQURsQyxVQUFLLEdBQUwsS0FBSyxDQUFPO1FBQ1osVUFBSyxHQUFMLEtBQUssQ0FBNkI7UUFHOUMsYUFBUSxHQUFnQixXQUFXLENBQUMsV0FBVyxDQUFDO1FBQ2hELGlCQUFZLEdBQW9CLGVBQWUsQ0FBQyxVQUFVLENBQUM7SUFIeEQsQ0FBQztJQUtKLElBQUksS0FBSztRQUNMLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQztJQUN0QixDQUFDO0lBRUQsT0FBTyxDQUFDLEdBQUcsRUFBRSxLQUFLO1FBQ2QsSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQy9CLENBQUM7SUFFRCxZQUFZO1FBQ1IsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQztJQUM5QixDQUFDO0lBRUQsUUFBUTtRQUNKLE1BQU0sS0FBSyxHQUFhLEVBQUUsQ0FBQztRQUMzQixJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLEtBQUssRUFBRSxHQUFHLEVBQUUsRUFBRTtZQUM5QixLQUFLLENBQUMsSUFBSSxDQUFDLEdBQUcsR0FBRyxDQUFDLFFBQVEsRUFBRSxJQUFJLEtBQUssQ0FBQyxRQUFRLEVBQUUsRUFBRSxDQUFDLENBQUM7UUFDeEQsQ0FBQyxDQUFDLENBQUM7UUFDSCxPQUFPLElBQUksS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDO0lBQ2xDLENBQUM7Q0FDSiJ9